import React from 'react';
import { useIntl } from 'react-intl';
import { useMagentoRoute } from '@magento/peregrine/lib/talons/MagentoRoute';
import ErrorView from '@magento/venia-ui/lib/components/ErrorView';
import { fullPageLoadingIndicator } from '@magento/venia-ui/lib/components/LoadingIndicator';
import { Meta } from "../Head";
var MESSAGES = new Map().set('NOT_FOUND', "Looks like the page you were hoping to find doesn't exist. Sorry about that.").set('INTERNAL_ERROR', 'Something went wrong. Sorry about that.');
var MagentoRoute = () => {
  var {
    formatMessage
  } = useIntl();
  var talonProps = useMagentoRoute();
  var {
    component: RootComponent,
    id,
    type,
    isLoading,
    isNotFound,
    isRedirect,
    sku
  } = talonProps;
  if (isLoading || isRedirect) {
    return fullPageLoadingIndicator;
  } else if (RootComponent) {
    return /*#__PURE__*/React.createElement(RootComponent, {
      id: id,
      type: type,
      sku: sku
    });
  } else if (isNotFound) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Meta, {
      name: "prerender-status-code",
      content: "404"
    }), /*#__PURE__*/React.createElement(ErrorView, {
      message: formatMessage({
        id: 'magentoRoute.routeError',
        defaultMessage: MESSAGES.get('NOT_FOUND')
      })
    }));
  }
  return /*#__PURE__*/React.createElement(ErrorView, {
    message: formatMessage({
      id: 'magentoRoute.internalError',
      defaultMessage: MESSAGES.get('INTERNAL_ERROR')
    })
  });
};
export default MagentoRoute;